module.exports = __webpack_public_path__ + "img/Vinje_Kritisk_journalist_med_tvisyn.7b7f9ebd.jpg";